/*
 * Curated boxes carousel
 * ------------------------------------------------------------
 * Powers sections/curated-boxes-carousel.liquid.
 *
 * 1) Express one-time add-to-cart:
 *    Clicking [data-curated-box-trigger] reads the nearest
 *    [data-curated-box-data] JSON and adds the box product as a single
 *    line (quantity 1) with the included variants attached as hidden
 *    `_pvgid://shopify/ProductVariant/<id>` line-item properties. No
 *    `selling_plan` is sent — that is what makes this a one-time purchase.
 *    This mirrors the bundling contract in assets/box-builder.js.
 *
 * 2) Carousel:
 *    Initializes a Swiper instance per [data-curated-boxes] container.
 *    Swiper is loaded globally (synchronously) from layout/theme.liquid, so
 *    it is available before this deferred script runs.
 */
(function () {
  'use strict';

  function cartAddUrl() {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    return url.endsWith('.js') ? url : url + '.js';
  }

  function buildProperties(items) {
    var properties = {};
    // Hidden marker so the cart can reliably detect a curated box line
    // without depending on reading the box variant's metafield at render time.
    properties['_ferdigboks'] = 'true';
    var slotIndex = 1;
    (items || []).forEach(function (item) {
      if (!item || !item.variantId) return;
      var qty = Number(item.quantity) || 1;
      properties['_pvgid://shopify/ProductVariant/' + item.variantId] = qty;
      // Bake a visible "Produkt N" label (like the Råvareboks box) so the cart
      // can list the contents even if the metafield can't be read there.
      if (item.name) {
        properties['Produkt ' + slotIndex] = qty > 1 ? item.name + ' x' + qty : item.name;
        slotIndex++;
      }
    });
    return properties;
  }

  function setTriggerLoading(trigger, isLoading) {
    if (!trigger) return;
    var label = trigger.querySelector('span') || trigger;

    if (isLoading) {
      if (!trigger.dataset.originalLabel) {
        trigger.dataset.originalLabel = label.textContent.trim();
      }
      trigger.disabled = true;
      trigger.setAttribute('aria-busy', 'true');
      label.textContent = 'Legger til...';
      return;
    }

    trigger.disabled = false;
    trigger.removeAttribute('aria-busy');
    if (trigger.dataset.originalLabel) {
      label.textContent = trigger.dataset.originalLabel;
      delete trigger.dataset.originalLabel;
    }
  }

  async function addBoxToCart(data, trigger) {
    if (!data || !data.containerId) {
      console.error('CuratedBoxes: missing containerId in box payload', data);
      return;
    }

    setTriggerLoading(trigger, true);

    // Mirror assets/product-form.js: works with either the cart notification
    // or the cart drawer, and repaints + opens whichever is present.
    var cart =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    var requestBody = {
      id: Number(data.containerId),
      quantity: 1,
      properties: buildProperties(data.items),
    };

    // One-time only: intentionally no `selling_plan`.

    if (cart && typeof cart.getSectionsToRender === 'function') {
      requestBody.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      requestBody.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    try {
      var response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(requestBody),
      });

      var json = await response.json();

      if (response.status === 422 || json.status) {
        console.error('CuratedBoxes: cart add failed', response.status, json);
        alert((json && json.description) || 'Kunne ikke legge boksen i handlekurven. Prøv igjen.');
        return;
      }

      // Keep the rest of the UI (cart count, etc.) in sync.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'curated-boxes',
          productVariantId: requestBody.id,
          cartData: json,
        });
      }

      // renderContents() repaints the drawer/notification sections and opens it.
      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(json);
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      console.error('CuratedBoxes: cart add error', error);
      alert('Noe gikk galt. Prøv igjen.');
    } finally {
      setTriggerLoading(trigger, false);
      // The cart starts with `is-empty`; product-form.js clears it after the
      // first add so the drawer shows items instead of the empty state.
      if (cart && cart.classList && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    }
  }

  // ── Express add-to-cart (delegated) ────────────────────────────────────
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-curated-box-trigger]');
    if (!trigger || trigger.disabled) return;

    var card = trigger.closest('[data-curated-box]');
    var dataEl = card && card.querySelector('[data-curated-box-data]');
    if (!dataEl) return;

    event.preventDefault();

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error('CuratedBoxes: failed to parse box payload', error);
      return;
    }

    addBoxToCart(data, trigger);
  });

  // ── Quick view (same modal component as product cards) ─────────────────
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-curated-quickview]');
    if (!trigger) return;

    var modalId = trigger.dataset.quickviewModal;
    var modal = modalId ? document.getElementById(modalId) : null;
    // If the modal component isn't ready yet, let the link navigate (fallback).
    if (!modal || typeof modal.show !== 'function') return;

    event.preventDefault();

    var productUrl = trigger.dataset.productUrl || trigger.getAttribute('href');
    if (!productUrl) return;

    // QuickAddModal.show() reads data-product-url from its opener and fetches
    // `?view=quick-view`. Build a lightweight hidden opener proxy.
    var opener = document.createElement('button');
    opener.setAttribute('data-product-url', productUrl);
    opener.style.display = 'none';
    document.body.appendChild(opener);

    modal.show(opener);

    var info = modal.querySelector('[id^="QuickAddInfo-"]');
    var cleanup = function () {
      if (opener.parentNode) opener.parentNode.removeChild(opener);
    };
    if (info) {
      var observer = new MutationObserver(function () {
        if (info.innerHTML.trim() !== '') {
          modal.openedBy = trigger;
          cleanup();
          observer.disconnect();
        }
      });
      observer.observe(info, { childList: true });
      setTimeout(function () {
        cleanup();
        observer.disconnect();
      }, 10000);
    } else {
      setTimeout(cleanup, 10000);
    }
  });

  // ── Carousel ───────────────────────────────────────────────────────────
  function initCarousel(container) {
    if (!container || container._curatedSwiper) return;
    if (typeof Swiper === 'undefined') return;

    var slidesDesktop = parseFloat(container.dataset.slidesDesktop) || 3;
    var slidesMobile = parseFloat(container.dataset.slidesMobile) || 1.2;
    var slidesTablet = Math.min(2, Math.max(1, Math.round(slidesDesktop)));

    var options = {
      slidesPerView: slidesMobile,
      spaceBetween: 16,
      a11y: { enabled: true },
      loop: container.dataset.loop === 'true',
      breakpoints: {
        768: { slidesPerView: slidesTablet, spaceBetween: 20 },
        992: { slidesPerView: slidesDesktop, spaceBetween: 24 },
      },
    };

    if (container.dataset.autoplay === 'true') {
      options.autoplay = {
        delay: (parseFloat(container.dataset.autoplaySpeed) || 5) * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    var pagination = container.querySelector('.swiper-pagination');
    if (pagination) {
      options.pagination = { el: pagination, clickable: true };
    }

    var nextEl = container.querySelector('.swiper-button-next');
    var prevEl = container.querySelector('.swiper-button-prev');
    if (nextEl && prevEl) {
      options.navigation = { nextEl: nextEl, prevEl: prevEl };
    }

    container._curatedSwiper = new Swiper(container, options);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-curated-boxes]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor: (re)initialize when the section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target.querySelector('[data-curated-boxes]');
    if (container && container._curatedSwiper) {
      container._curatedSwiper.destroy(true, true);
      container._curatedSwiper = null;
    }
  });
})();
